import useMediaSelectionActions from '@/actions/useMediaSelectionActions'
import ShareScreenIcon from '@/CustomIcons/ShareScreenIcon'
import { AnalyticsEvents } from '@/services/AnalyticsService'
import useAnalytics from '@/services/useAnalytics'
import useRoomViews from '@/services/useRoomViews'
import MenuButton from '@/UIComponents2/MenuButton/MenuButton'
import { useTranslation } from 'react-i18next'

type ShareScreenMenuButtonProps = {
    labelPosition?: 'inside' | 'outside'
    triggerClassName?: string
}
const ShareScreenMenuButton = (props: ShareScreenMenuButtonProps) => {
    const { t } = useTranslation()
    const { isPresenting } = useRoomViews()

    const { openShareScreenDialog } = useMediaSelectionActions()
    const { logUserActivityWithContext } = useAnalytics()

    return (
        <MenuButton
            icon={<ShareScreenIcon withGradient={isPresenting} style={{ fontSize: '1.3rem' }} />}
            label={t('Share Screen')}
            labelPosition={props.labelPosition}
            triggerClassName={props.triggerClassName}
            tooltip={{
                text: t('Share your screen'),
                variant: 'info',
            }}
            onIconClick={() => {
                openShareScreenDialog()
                logUserActivityWithContext(AnalyticsEvents.CLICKED_SHARE_SCREEN_BUTTON, {
                    componentSource: 'VideoGalleryBottomToolbar',
                })
            }}
        />
    )
}

export default ShareScreenMenuButton
